"use client";

import { useState } from "react";
import { motion } from "framer-motion";

const faqs = [
  {
    q: "What HVAC services do you provide?",
    a: "We provide installation, repair, maintenance, and full HVAC system setup for residential and commercial buildings.",
  },
  {
    q: "Do you offer emergency HVAC repair?",
    a: "Yes, we offer 24/7 emergency support for heating and cooling system breakdowns.",
  },
  {
    q: "How quickly can you respond?",
    a: "Usually within a few hours depending on your location and urgency.",
  },
  {
    q: "Do you install new systems?",
    a: "Yes, we handle complete HVAC installation for homes, offices, and commercial projects.",
  },
  {
    q: "Is maintenance available?",
    a: "Yes, we offer maintenance plans to improve efficiency and system life.",
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState(0);

  const toggle = (i) => {
    setOpenIndex(openIndex === i ? -1 : i);
  };

  return (
    <section className="relative py-24 bg-black overflow-hidden">

      {/* 🔵 Glow Background */}
      {/* <div className="absolute inset-0">
        <div className="absolute top-[-180px] left-1/2 -translate-x-1/2 w-[700px] h-[700px] bg-blue-600/20 blur-[160px] rounded-full" />
        <div className="absolute bottom-[-180px] left-[-120px] w-[500px] h-[500px] bg-indigo-600/20 blur-[140px] rounded-full" />
        <div className="absolute bottom-[-180px] right-[-120px] w-[500px] h-[500px] bg-sky-600/20 blur-[140px] rounded-full" />
      </div> */}

      <div className="relative max-w-4xl mx-auto px-6">

        {/* Heading */}
        <div className="text-center mb-14">
          <h2 className="text-4xl font-bold text-white">
            Frequently Asked Questions
          </h2>
          <p className="text-gray-400 mt-3">
            Quick answers about our HVAC services
          </p>
        </div>

        {/* FAQ Items */}
        <div className="space-y-4">

          {faqs.map((item, i) => {
            const isOpen = openIndex === i;

            return (
              <motion.div
                key={i}
                layout
                className="border border-white/10 bg-white/5 backdrop-blur-xl rounded-2xl overflow-hidden"
              >

                <button
                  onClick={() => toggle(i)}
                  className="w-full flex justify-between items-center p-6 text-left"
                >
                  <span className="font-semibold text-white">
                    {item.q}
                  </span>

                  <span className="text-xl text-gray-400">
                    {isOpen ? "−" : "+"}
                  </span>
                </button>

                {isOpen && (
                  <motion.div
                    initial={{ opacity: 0, height: 0 }}
                    animate={{ opacity: 1, height: "auto" }}
                    className="px-6 pb-6 text-gray-300 text-sm leading-relaxed"
                  >
                    {item.a}
                  </motion.div>
                )}

              </motion.div>
            );
          })}

        </div>

        {/* bottom CTA */}
        <div className="text-center mt-12 text-gray-400">
          Didn’t find your answer?{" "}
          <a href="#" className="text-blue-400 font-medium hover:underline">
            Contact us
          </a>
        </div>

      </div>
    </section>
  );
}